var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0);}.b,.c{fill:none;}.c{stroke:#333;stroke-linecap:round;stroke-width:2px;}.d,.e{stroke:none;}.e{fill:#333;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(9750 -3100)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-9742,3120h7a2.123,2.123,0,0,0,2-2.223v-15.555a2.123,2.123,0,0,0-2-2.222h-7a2.123,2.123,0,0,0-2,2.222v2.223h2v-2.223h7v15.555h-7v-2.222h-2v2.222A2.123,2.123,0,0,0-9742,3120Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M -9735 3120 L -9741.9990234375 3120 C -9743.1015625 3120 -9743.9990234375 3119.0029296875 -9743.9990234375 3117.777099609375 L -9743.9990234375 3115.554931640625 L -9741.9990234375 3115.554931640625 L -9741.9990234375 3117.777099609375 L -9735 3117.777099609375 L -9735 3102.222412109375 L -9741.9990234375 3102.222412109375 L -9741.9990234375 3104.445068359375 L -9743.9990234375 3104.445068359375 L -9743.9990234375 3102.222412109375 C -9743.9990234375 3100.9970703125 -9743.1015625 3100 -9741.9990234375 3100 L -9735 3100 C -9733.8974609375 3100 -9733 3100.9970703125 -9733 3102.222412109375 L -9733 3117.777099609375 C -9733 3119.0029296875 -9733.8974609375 3120 -9735 3120 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.999)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M12,0H2",
    transform: "translate(-2 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M9764-3092l-4,4,4,4",
    transform: "translate(-9760 3092)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.931468f827132fdda6ffc379c75ee44d.svg";
export { ForwardRef as ReactComponent };